import React from "react";
import ReactHtmlParser from "react-html-parser";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

const padNumber = value =>
  value || value === 0 ? String(value).padStart(2, "0") : null;

/**
 * "What You Can Do" — a dark panel holding the large step-01 card (state laws,
 * map and state pills) followed by the remaining numbered action cards.
 */
const HempBanWhatCanDo = ({ whatCanDo }) => {
  if (!whatCanDo) {
    return null;
  }

  const {
    badgeText,
    topText,
    number,
    heading,
    text,
    rightHeading,
    statesMapImage,
    statesNames = [],
    cards = []
  } = whatCanDo;

  const states = (statesNames || []).filter(item => item && item.state);

  return (
    <section className="hb-section hb-can-do">
      <div className="hb-container">
        <div className="hb-can-do-panel">
          <HempBanSectionHead badgeText={badgeText} theme="dark">
            {topText ? (
              <div className="hb-can-do-intro hb-rich">
                {ReactHtmlParser(topText)}
              </div>
            ) : null}
          </HempBanSectionHead>

          <div className="hb-can-do-main">
            <div className="hb-can-do-main-left">
              {padNumber(number) ? (
                <span className="hb-can-do-num">{padNumber(number)}</span>
              ) : null}
              {heading ? (
                <h2 className="hb-can-do-heading">{heading}</h2>
              ) : null}
              {text ? (
                <div className="hb-can-do-text hb-rich">
                  {ReactHtmlParser(text)}
                </div>
              ) : null}
            </div>

            <div className="hb-can-do-main-right">
              {rightHeading ? (
                <h4 className="hb-can-do-right-heading">{rightHeading}</h4>
              ) : null}

              {statesMapImage?.sourceUrl ? (
                <div className="hb-can-do-map">
                  <img
                    src={replaceImageCdn(statesMapImage.sourceUrl)}
                    alt={
                      statesMapImage.altText ||
                      rightHeading ||
                      "States with state-licensed cannabis markets"
                    }
                    loading="lazy"
                  />
                </div>
              ) : null}

              {states.length ? (
                <ul className="hb-state-pills">
                  {states.map((item, index) => (
                    <li
                      className="hb-state-pill"
                      key={`${item.state}-${index}`}
                    >
                      {item.state}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </div>

          {cards && cards.length ? (
            <div className="hb-can-do-grid">
              {cards.map((card, index) => (
                <article
                  className="hb-can-do-card"
                  key={`${card.heading || "card"}-${index}`}
                >
                  {card.image?.sourceUrl ? (
                    <span className="hb-can-do-card-icon" aria-hidden="true">
                      <img
                        src={replaceImageCdn(card.image.sourceUrl)}
                        alt=""
                        loading="lazy"
                      />
                      <img
                        className="hb-can-do-card-icon-glow"
                        src={replaceImageCdn(card.image.sourceUrl)}
                        alt=""
                        loading="lazy"
                      />
                    </span>
                  ) : null}
                  {padNumber(card.number) ? (
                    <span className="hb-can-do-card-num">
                      {padNumber(card.number)}
                    </span>
                  ) : null}
                  {card.heading ? (
                    <h3 className="hb-can-do-card-heading">{card.heading}</h3>
                  ) : null}
                  {card.text ? (
                    <div className="hb-can-do-card-text hb-rich">
                      {ReactHtmlParser(card.text)}
                    </div>
                  ) : null}
                </article>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default HempBanWhatCanDo;
